import { DemoClientPhotoCatalog } from './DemoClientPhotoCatalog';

/**
 * The photos the invented caseload wears: stock portraits bundled with the app, dealt out afresh
 * each time the demo is turned on or its caseload is read again, so no two demos show the same
 * faces in the same places and nobody learns to read a face as a particular client.
 */
export class DemoClientPhotos {
    static inject = () => [DemoClientPhotoCatalog];

    constructor(private catalog: DemoClientPhotoCatalog) {}

    /**
     * One photo per client, in a random order, each used once before any is used twice. Empty for an
     * empty catalogue, rather than dealing for ever.
     */
    deal = ({ count, random = Math.random }: { count: number; random?: () => number }): string[] => {
        const { files } = this.catalog;
        if (files.length === 0) {
            return [];
        }
        const dealt: string[] = [];
        while (dealt.length < count) {
            dealt.push(...this.shuffle(files, random));
        }
        return dealt.slice(0, count);
    };

    private shuffle = (files: string[], random: () => number): string[] => {
        const shuffled = [...files];
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        return shuffled;
    };
}
